import { z } from 'zod';
/** Saved promotion data used by the price-smash Offer pane. */
export const resolvedOfferCardSchema = z.object({
    serviceName: z.string(),
    serviceDescription: z.string().optional(),
    headline: z.string().optional(),
    originalPriceCents: z.number().int().optional(),
    offerPriceCents: z.number().int().optional(),
    discountPercent: z.number().optional(),
    urgencyText: z.string().optional(),
    audienceText: z.string().optional(),
    bulletPoints: z.array(z.string()).optional(),
    ctaText: z.string(),
    logoUrl: z.string().optional(),
    businessName: z.string().optional(),
    primaryColor: z.string().optional(),
    secondaryColor: z.string().optional(),
    currencyCode: z.string().optional(),
    logoBackgroundColor: z.string().optional(),
    logoBackdropUrl: z.string().optional(),
});
//# sourceMappingURL=offer-card.js.map